export function decodeJwt(token) {
  if (!token) return null

  let parts = token.split('.')
  if (parts.length !== 3) return null

  let encodedPayload = parts[1]
  let json = atob(encodedPayload)
  let decoded = JSON.parse(json)

  return decoded
}
